/* Little Rebels — light interactivity layer. */
(function () {
  'use strict';

  /* Toggle data-rebels-scrolled on <body> based on scroll position.
     Used by rebels.css to give the header a background + border once scrolled. */
  function initScrollState() {
    var threshold = 40;
    var ticking = false;

    function update() {
      var scrolled = window.scrollY > threshold;
      document.body.dataset.rebelsScrolled = scrolled ? 'true' : 'false';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    initScrollState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
